import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "ModalPopUp",
  ref: "createAppModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Ürün Birleştir", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal",
  id: "CloseMergeModal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", null, "Seçili Ürün", -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", null, "Mevcut Eşleşmeler", -1)
const _hoisted_12 = { style: {"width":"95px","display":"inline-block"} }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "mh-300px scroll-y me-n7 pe-7" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "ms-5" }
const _hoisted_19 = { class: "fs-7 fw-bolder text-gray-900 text-hover-primary mb-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-nav ps-lg-10" }, null, -1)
const _hoisted_22 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("p", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SelectedProduct?.name?.split(' '), (itm, i) => {
              return (_openBlock(), _createElementBlock("a", {
                key: i,
                onClick: ($event: any) => (_ctx.filterparams = itm)
              }, _toDisplayString(itm) + "   ", 9, _hoisted_10))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SelectedProduct?.integrationProducts, (iProduct, ii) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: ii }, [
                _createTextVNode(" (" + _toDisplayString(_ctx.IIntegrationElement.twoLetter(iProduct)) + ") ", 1)
              ], 64))
            }), 128))
          ]),
          _hoisted_11,
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SelectedProduct?.integrationProducts, (iProduct, ii) => {
              return (_openBlock(), _createElementBlock("li", { key: ii }, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.IIntegrationElement.friendlyName(iProduct)) + " : ", 1),
                _createTextVNode(" " + _toDisplayString(iProduct.product?.Name) + " ", 1),
                _createElementVNode("button", {
                  style: {"justify-content":"center"},
                  type: "button",
                  class: "btn btn-secondary er fs-7 px-2 py-2",
                  onClick: ($event: any) => (
                    _ctx.removeItem(_ctx.SelectedProduct,_ctx.SelectedProduct?.integrationProducts.indexOf(iProduct))
                  )
                }, " SİL ", 8, _hoisted_13)
              ]))
            }), 128))
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid",
              name: "row-name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterparams) = $event)),
              placeholder: "filtrele"
            }, null, 512), [
              [_vModelText, _ctx.filterparams]
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtervaluem as ProductNGDTO[], (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex flex-stack py-1 border-bottom border-gray-300 border-bottom-dashed"
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("a", _hoisted_19, [
                        _createTextVNode(_toDisplayString(item.name) + " ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.integrationProducts, (iProduct, ii) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: ii }, [
                            _createTextVNode(" (" + _toDisplayString(_ctx.IIntegrationElement.twoLetter(iProduct)) + ") ", 1)
                          ], 64))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    style: {"justify-content":"center"},
                    type: "button",
                    class: "btn btn-primary er fs-7 px-2 py-2",
                    onClick: ($event: any) => (
                    _ctx.Combine(item, _ctx.SelectedProduct, _ctx.Valuem as ProductNGDTO[])
                    )
                  }, " + ", 8, _hoisted_20)
                ]))
              }), 128))
            ]),
            _hoisted_21
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            style: {"background-color":"green","margin-left":"2px"},
            type: "button",
            class: "btn btn-primary er fs-6 px-8 py-4",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setdata(_ctx.SelectedProduct)))
          }, " Kaydet ")
        ])
      ])
    ])
  ], 512))
}